import {
  FETCH_TRANSFER_CASH_BY_CODE_CREATE_REQUEST,
  FETCH_TRANSFER_CASH_BY_CODE_CREATE_SUCCESS,
  FETCH_TRANSFER_CASH_BY_CODE_CREATE_FAILURE,
  FETCH_TRANSFER_CASH_BY_CODE_CONFIRM_REQUEST,
  FETCH_TRANSFER_CASH_BY_CODE_CONFIRM_SUCCESS,
  FETCH_TRANSFER_CASH_BY_CODE_CONFIRM_FAILURE,
  FETCH_TRANSFER_CASH_BY_CODE_AUTHORIZATION_KEY_REQUEST,
  FETCH_TRANSFER_CASH_BY_CODE_AUTHORIZATION_KEY_SUCCESS,
  FETCH_TRANSFER_CASH_BY_CODE_AUTHORIZATION_KEY_FAILURE,
} from "./actions.type";

import { TransferCashByCodeState, TransferCashByCodeActions } from "./types";

const initialState: TransferCashByCodeState = {
  pending: false,
  error: undefined,
  isCreated: false,
  isConfirm: false,
  isAuthorization: false,
};

export default (state = initialState, action: TransferCashByCodeActions): TransferCashByCodeState => {
  switch (action.type) {
    case FETCH_TRANSFER_CASH_BY_CODE_CREATE_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case FETCH_TRANSFER_CASH_BY_CODE_CREATE_SUCCESS:
      return {
        ...state,
        pending: false,
        isCreated: true,
        error: undefined,
      };
    case FETCH_TRANSFER_CASH_BY_CODE_CREATE_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case FETCH_TRANSFER_CASH_BY_CODE_CONFIRM_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case FETCH_TRANSFER_CASH_BY_CODE_CONFIRM_SUCCESS:
      return {
        ...state,
        pending: false,
        isConfirm: true,
        error: undefined,
      };
    case FETCH_TRANSFER_CASH_BY_CODE_CONFIRM_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case FETCH_TRANSFER_CASH_BY_CODE_AUTHORIZATION_KEY_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case FETCH_TRANSFER_CASH_BY_CODE_AUTHORIZATION_KEY_SUCCESS:
      return {
        ...state,
        pending: false,
        isAuthorization: true,
        error: undefined,
      };
    case FETCH_TRANSFER_CASH_BY_CODE_AUTHORIZATION_KEY_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    default:
      return {
        ...state,
      };
  }
};
